import * as React from "react"
import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

// Função auxiliar para validar e sanitizar conteúdo
const sanitizeContent = (content: unknown): React.ReactNode => {
  if (typeof content === 'string' || typeof content === 'number') {
    return content;
  }
  if (React.isValidElement(content)) {
    return content;
  }
  if (content === null || content === undefined) {
    return null;
  }
  if (typeof content === 'object') {
    console.warn('Tentativa de renderizar objeto no Toast:', content);
    return JSON.stringify(content);
  }
  if (
    typeof content === 'boolean' ||
    typeof content === 'bigint' ||
    typeof content === 'symbol' ||
    typeof content === 'function'
  ) {
    return String(content);
  }
  // Inalcançável pelo Toaster: os resultados de `typeof` já foram tratados acima.
  // A única exceção da linguagem, `document.all` (typeof 'undefined', mas
  // diferente de undefined), é falsy e é barrada pelo `title &&`/`description &&`.
  throw new TypeError(`Conteúdo de toast não suportado: ${typeof content}`);
};

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{sanitizeContent(title)}</ToastTitle>}
              {description && (
                <ToastDescription>{sanitizeContent(description)}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
